import { createTracker } from './config';

// 全局埋点实例
let globalTracker: any = null;

// 初始化埋点
export const initTracking = async () => {
  try {
    globalTracker = await createTracker();
    console.log('aaaaaaanew globalTracker', globalTracker);
    await globalTracker.init();
    console.log('埋点初始化成功');
    return globalTracker;
  } catch (error) {
    console.error('埋点初始化失败:', error);
    // throw error;
  }
};

// 获取埋点实例
export const getTracker = () => {
  if (!globalTracker) {
    throw new Error('埋点未初始化，请先调用 initTracking()');
  }
  return globalTracker;
};

// 便捷方法
export const track = (eventName: string, params: any) => {
  try {
    const tracker = getTracker();
    // console.log('aaaaaaanew tracker', tracker, eventName, params);
    tracker.track(eventName, params);
  } catch (error) {
    console.error('埋点记录失败:', error);
  }
};

export const trackPageView = (
  pageName: string,
  pageTitle?: string,
  properties?: any
) => {
  const tracker = getTracker();
  tracker.trackPageView(pageName, pageTitle, properties);
};

export const setUserId = (userId: string) => {
  const tracker = getTracker();
  tracker.setUserId(userId);
};
